import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import styled from 'styled-components';
import { BidChanceHistory } from '../../modules/bid-chances';
import { styledTable } from '../styled/mixin';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface BidChanceHistoryListComponentProps {
  bidChanceHistories: BidChanceHistory[];
}

function BidChanceHistoryListComponent({
  bidChanceHistories,
}: BidChanceHistoryListComponentProps) {
  const columns: ColumnsType<BidChanceHistory> = [
    // {
    //   title: '회사명',
    //   // dataIndex: ['user', 'myEnterprise', 'name'],
    //   render: (text: any, record: any, index: any) =>
    //     record.user === null
    //       ? record.userData.companyName
    //       : record.user.myEnterprise.name,
    // },
    // {
    //   title: '이름',
    //   // dataIndex: ['user', 'name'],
    //   render: (text: any, record: any, index: any) =>
    //     record.user === null
    //       ? `${record.userData.name}(${phoneFormatter(
    //           record.userData.personalPhone,
    //           1,
    //         )})`
    //       : `${record.user.name}(${phoneFormatter(
    //           record.user.personalPhone,
    //           1,
    //         )})`,
    // },
    {
      title: '설명',
      dataIndex: 'description',
      width: '70%',
      render: (text: any, record: any, index: any) => (
        <div style={{ whiteSpace: 'pre-wrap' }}>{record.description}</div>
      ),
    },
    {
      title: '변경일시',
      dataIndex: 'createdAt',
      width: '30%',
      render: (text: any, record: any, index: any) =>
        moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss'),
    },
    // {
    //   title: '비고',
    //   width: '20%',
    // },
  ];

  return (
    <StyledDiv>
      <h3>히스토리</h3>
      <Table<BidChanceHistory>
        rowKey="id"
        columns={columns}
        dataSource={bidChanceHistories}
        pagination={false}
      />
    </StyledDiv>
  );
}

export default BidChanceHistoryListComponent;
